export const FIRST_LINE_POINT_MODE_TOGGLE = 'FIRST_LINE_POINT_MODE_TOGGLE';
export const CREATE_MODE_TOGGLE = 'CREATE_MODE_TOGGLE';
export const EXTRA_OBJECT_CREATE = 'EXTRA_OBJECT_CREATE';
export const EXTRA_OBJECT_DELETE = 'EXTRA_OBJECT_DELETE';